<template>
  
  <div :class="`board-card ${color} board-${type}`">
    <div class="header">
      <img v-if="type" :src="`head/title-${type}.svg`|img">
    </div>
    <div class="time">
      <img :src="`board/lattice-${color}.svg`|img"/>
      <div class="number" v-html="timer"></div>
      <div class="sub">
        <span>天 days</span>
        <span>时 hours</span>
        <span>分 mins</span>
      </div>
    </div>
    <small>距榜单公布时间</small>
  </div>
</template>

<script>
export default {
  name: 'Board',
  props: {
    'type': String,
    'color': String,
    'timer': String,
  },
  data(){
    // console.log(this.table);
    return {
    };
  },
  methods:{
  }
}
</script>

<style lang="less">
.board-card{
  background-size: cover;
  margin: 16px;
  background-color: #fff;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
  text-align: left;
  position: relative;
  .back{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    min-height: 100%;
  }
  .header{
    height: 48px;
    padding: 13px;
    text-align: center;
    background-image: url('~@/assets/head/title-back-f.png');
    background-size: 100% 100%;
  }
  .header img{
    height: 24px;
    width: auto;
  }
  &.gold{
    small,.time .sub span{
      color: #D79B56;
    }
  }
  .time{
    position: relative;
    margin: 18px 16px;
    .number{
      position: absolute;
      top: 0;
      left: 6px;
      font-weight: bold;
      font-size: 28px;
      color: #fff;
      line-height: 50px;
      letter-spacing: 12px;
    }
    .number i{
      display: inline-block;
      margin-right: 12.5px;
      width: 55px;
      text-align: center;
    }
    .sub{
      margin: 1px 3px;
      span{
        margin-right: 16px;
      }
    }
    img{
      width: 193px;
    }
  }
  small{
    margin: 12px 16px;
    display: block;
    font-size: 12px;
    color: #727272;
    opacity: 0.65;
  }

  @media (min-width: 987px) {
    margin: 16px 0;
    text-align: center;
    .header{
      text-align: center;
      height: 60px;
      background-image: url('~@/assets/head/title-back-pc.png');
      img{
        height: 30px;
      }
    }
    .back{
      height: 80px;
      min-height: 0;
    }
    .time{
      img{
        width: 315px;
      }
      .number{
        left: 50%;
        margin-left: -145px;
        line-height: 80px;
        i{
          font-size: 36px;
          margin-right: 20px;
          letter-spacing: 23px;
          width: 90px;
        }
      }
      .sub{
        span{
          margin: 0 0 0 12px;
          width: 98px;
          display: inline-block;
          text-align: left;
        }
      }
    }
  }
}
</style>
